/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner } from './get-merchant-general-block-detail200-response-allowed-organization-list-inner';

/**
 * 
 * @export
 * @interface GetMerchantGeneralBlockDetail200Response
 */
export interface GetMerchantGeneralBlockDetail200Response {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'patternType': GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'storeType': GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner>}
     * @memberof GetMerchantGeneralBlockDetail200Response
     */
    'allowedOrganizationList': Array<GetMerchantGeneralBlockDetail200ResponseAllowedOrganizationListInner>;
}

export const GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum = typeof GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum[keyof typeof GetMerchantGeneralBlockDetail200ResponsePatternTypeEnum];
export const GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum = typeof GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum[keyof typeof GetMerchantGeneralBlockDetail200ResponseStoreTypeEnum];


